// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ch-2";
export var aiChatCartContainerExit = "_ch-4";
export var aiChatContainerLarge = "_ch-0";
export var aiChatContainerSmall = "_ch-1";
export var aiChatIcon = "_ch-6";
export var slideInFromRight = "_ch-3";
export var slideOutToRight = "_ch-5";